import { useRouter } from '../../../hooks';

interface Params {
    navigateRouteOnError: string;
}

export const useProcessIdParam = ({ navigateRouteOnError }: Params) => {
    const { query, navigate } = useRouter();

    const { processId } = query as { processId?: string };
    if (!sessionStorage.getItem('theia-token') && !processId) {
        navigate(navigateRouteOnError, { replace: true });
    }

    return processId;
};
